import { SdohStatus } from 'common-src/models/PatientSdoh';

export const initialState = {
  sdohCodeId: null,
  status: SdohStatus.Active,
  note: '',
};
